import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./ticket.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import moments from "moment-timezone";
import { IoMdCheckmarkCircle } from "react-icons/io";
import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid } from "uuid";
import moment from "moment";
import { GrUpdate } from "react-icons/gr";
// import ImageModal from "../Model/ImageModel";
import {
  copyTextToClipboard,
  nopagepermission,
  primaryColor,
  utrLeng,
} from "../../utils/comman/Common";

import DropdownMenus from "./dropdownCollaps";
import {
  TicketStatusoptions,
  createdOnDate,
  isNotSuccess,
  singleTicket,
} from "../../utils/Constant";
import UILoader from "../../utils/comman/loader";

export function calculateTimeDifference(startTime, endTime, userTimeZone) {
  const currentUserTime = moments().tz(userTimeZone);
  const startMoment = moments(startTime).tz(userTimeZone); // Assuming startTime and endTime are already in the user's time zone
  const endMoment = moments(endTime).tz(userTimeZone);
  const timeDifference = endMoment.diff(startMoment);
  const duration = moments.duration(timeDifference);

  // Format the duration
  const daysPart = duration.days() > 0 ? `${duration.days()}Days, ` : "";
  const formattedDuration = `${daysPart}${duration.hours()}:${duration.minutes()}:${duration.seconds()}`;

  return formattedDuration;
}
export default function TicketDeatails(props) {
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const roles = useSelector((state) => state.authReducer?.auth?.roles);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );

  const [axiosInstance] = axiosinstances();
  const location = useLocation();
  const [txnId, setTxnId] = useState("");
  const [ticketId, seTicketId] = useState("");
  // const [userUtr, setUserUtr] = useState("");
  const [data, setdata] = useState(null);
  const [loading, setLoading] = useState(false);
  const intialComment = data?.comments || [];
  const intialuserTxnDate = data?.userTxnDate || [];
  const [comments, setComments] = useState("");
  const [internalcomments, setInternalcomments] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isinternalCollapsed, setIsinternalCollapsed] = useState(true);
  const [attachmentId, setattachmentId] = useState(null);
  const [internalattachmentId, setInternalattachmentId] = useState(null);
  const [imgdata, setimgData] = useState([]);
  const [dataForUpdateUtr, setDataForUpdateUtr] = useState({});
  const [showUpdateUtr, setShowUpdateUtr] = useState(false);
  const [userTxDate, setUserTxDate] = useState(intialuserTxnDate);
  const [userUtrs, setUserUtrs] = useState(data?.userUtr);
  const [assignTo, setAssignTo] = useState("");
  const e = JSON.parse(sessionStorage.getItem("token"));
  const accessPath = process.env.REACT_APP_accessPath;
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedStatusOption, setSelectedStatusOption] = useState("");

  const [show, setshow] = useState(false);
  function getInitials(name) {
    if (!name) return "";

    const words = name.trim().split(" ");
    let initials = "";

    for (let i = 0; i < words.length; i++) {
      initials += words[i][0];
    }

    return initials;
  }
  console.log("data1", data);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setIsinternalCollapsed(true);
  };
  const toggleInternalCollapse = () => {
    setIsCollapsed(true);
    setIsinternalCollapsed(!isinternalCollapsed);
  };
  const getDayAgoUpdate = (updatedOn) => {
    const today = moment();

    const endMoment = moment(updatedOn);
    // Parse the dates using Moment.js

    const differenceInDays = endMoment.diff(today, "days");
    // console.log("differenceInDays", differenceInDays);
    return differenceInDays;
  };
  const handleOpenUpdateUtr = (e, data) => {
    setDataForUpdateUtr(data?.payInTxn);
    setTxnId(data?.payInTxn?.id);
    seTicketId(data?.id);
    setShowUpdateUtr(true);
  };
  const handleCloseUpdateUtr = () => {
    setShowUpdateUtr(false);
    setDataForUpdateUtr({});
  };
  console.log("dataForUpdateUtr", data);
  const openImageModal = (base64Content) => {
    setSelectedImage(base64Content);
    setshow(true);
  };
  function areDatesSame(date1, date2) {
    // Check if date1 is the same as date2 (ignoring time)
    return moment(date1).isSame(date2, "day");
  }
  function areStatusSame(val1, val2) {
    // Check if date1 is the same as date2 (ignoring time)
    return val1 == val2;
  }

  function getTodaytDateTime() {
    return moment().format("YYYY-MM-DD HH:mm:ss");
  }
  const closeImageModal = () => {
    setSelectedImage(null);
    setshow(false);
  };
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": id,
    "access-path": accessPath,
  };

  const fetchTicketDetails = async (id) => {
    const newData = [];
    setLoading(true);
    const API_ENDPOINT = `/api/v1/finxpay/complaint/getComplaint/${id}`;
    try {
      const response = await axiosInstance.get(`${API_ENDPOINT}`, {
        headers,
      });

      // console.log('ticketValues', ticketValues)
      if (response?.data?.success) {
        const ticketValues = response.data?.ticket;

        setdata(ticketValues);
        setAssignTo(ticketValues?.lastAssignedTo);
        setSelectedStatusOption(ticketValues?.currentStatus);
        // setUserUtrs(ticketValues?.tickets[0]?.userUtr);
        // setUserTxDate(ticketValues?.tickets[0]?.userTxnDate);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (location.state?.data?.ticketId !== undefined) {
      fetchTicketDetails(location.state?.data?.ticketId);
    }
  }, []);

  const submitComment = async (e) => {
    e.preventDefault();
    const requestPayload = {
      header: {
        msgType: "STATUS_UPDATE",
        service: "MOBILE",
        src: null,
        dst: null,
        channel: "WHITELABEL",
        requesterId: "A0822450215EM",
        requestId: uuid(),
        time: new Date().toISOString(),
        traceId: uuid(),
        hops: null,
      },
      ticketId: data?.ticketId,
      updatedBy: id,
      status: selectedStatusOption,
      assignedTo: assignTo,
      comment: comments && comments !== "" ? comments : null,
      operatorId: null,
      ip: "127.1.1.1",
    };

    if (comments == "") {
      toast.error("Enter Your Comments");
      return;
    }

    //setDataLoading(true);
    const API_ENDPOINT = "/api/v1/finxpay/complaint/update" + `?user=${id}`;
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.success) {
        toast.success(`Your comment added`);
        // setUserComments(response?.data?.comments);
        // setdata(response?.data);
        setComments("");

        fetchTicketDetails(response?.data?.ticketId);
      } else {
        setComments("");
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };

  const submitStatus = async (e) => {
    e.preventDefault();
    const requestPayload = {
      header: {
        msgType: "STATUS_UPDATE",
        service: "MOBILE",
        src: null,
        dst: null,
        channel: "WHITELABEL",
        requesterId: "A0822450215EM",
        requestId: uuid(),
        time: new Date().toISOString(),
        traceId: uuid(),
        hops: null,
      },
      ticketId: data?.ticketId,
      updatedBy: id,
      status: selectedStatusOption,
      assignedTo: assignTo,
      comment: comments && comments !== "" ? comments : null,
      operatorId: null,
      ip: "127.1.1.1",
    };
    if (selectedStatusOption == "NEW") {
      toast.warn("You can not change status NEW");
      return;
    }
    const API_ENDPOINT = "/api/v1/finxpay/complaint/update" + `?user=${id}`;
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.success) {
        toast.success(`Your status has updated`);

        fetchTicketDetails(response?.data?.ticketId);
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };
  const handleDropdownChange = (e) => {
    setSelectedStatusOption(e.target.value);
  };

  const checkDisableBystatus = () => {
    let disable = true;

    if (data?.currentStatus !== selectedStatusOption) {
      disable = false;
    }

    if (data?.lastAssignedTo !== assignTo) {
      disable = false;
    }
    console.log(
      "data?.status",
      data?.currentStatus,
      selectedStatusOption,
      data?.currentStatus !== selectedStatusOption,
      data?.lastAssignedTo,
      assignTo,
      data?.lastAssignedTo !== assignTo,
      disable
    );
    return disable;
  };

  return (
    <>
      {/* <UpdateUtr
        show={showUpdateUtr}
        handleClose={handleCloseUpdateUtr}
        headers={headers}
        dataForUpdateUtr={dataForUpdateUtr}
        setDataForUpdateUtr={setDataForUpdateUtr}
        updateStatusFromTicketPage={true}
        txnId={txnId}
        userUtr={userUtrs}
        ticketId={ticketId}
        fetchTicketDetails={fetchTicketDetails}
        // call get ticket
      /> */}
      <div>
        {/* <nav class="navbar navbar-expand-lg bg-white fixed-top ">
        <div class="container-fluid">

            <a class="navbar-brand align-self-baseline" href="#"><i class="fa-solid fa-bars me-3"></i>Jira Software</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"
                aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 text-dark">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Your Work
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Projects
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Filters
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Dashboard
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Teams
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Apps
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" href="#">
                            <button class="btn bg-primary p-0 px-1  text-white " data-bs-toggle="modal"
                                data-bs-target="#exampleModal">Create</button></a>
                    </li>
                </ul>
                <form class="d-flex" role="search">
                    <input class="form-control " type="search" placeholder="Search" aria-label="Search"/>
                    <button class="btn m-0 p-0 " type="submit"><i
                            class="fa-solid fa-bell content-hover p-2"></i></button>
                    <button class="btn m-0 p-0 " type="submit"><i
                            class="fa-solid fa-question content-hover p-2"></i></button>
                    <button class="btn m-0 p-0 " type="submit"><i
                            class="fa-solid fa-gear content-hover p-2"></i></button>
                    <div class="bg-primary rounded-circle text-white w-25 h-25 py-2 text-center">
                        CT
                    </div>
                </form>
            </div>
        </div>
    </nav> */}
        {/* <!-- Modal --> */}
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content">
              {/* <!-- model header --> */}
              <div class="modal-header d-flex ">
                <div>
                  <h1 class="modal-title fs-5" id="exampleModalLabel">
                    Create Issue
                  </h1>
                </div>
                <div>
                  <button type="button" class="btn">
                    <i class="fa fa-minus fs-5"></i>
                  </button>
                  <button type="button" class="btn">
                    <i class="fa-solid fa-arrow-down fs-5"></i>
                  </button>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
              </div>
              {/* <!-- model body --> */}
              <div class="modal-body">
                <div class="container">
                  {/* <!-- project  first row --> */}
                  <div class="row">
                    <div class="col-6">
                      <div class="project-model">
                        <label for="">
                          Project <span class="text-danger">*</span>
                        </label>
                        <select name="" id="" class="form-select mb-3 bg-light">
                          <option value="">option1</option>
                          <option value="">option2</option>
                          <option value="">option3</option>
                        </select>

                        <label for="">
                          Issue Type<span class="text-danger">*</span>
                        </label>
                        <select name="" id="" class="form-select bg-light">
                          <option value="">
                            <i
                              class="fa-solid fa-square-check"
                              style={{ color: "#7ea6ec" }}
                            ></i>{" "}
                            Task
                          </option>
                          <option value="">option2</option>
                          <option value="">option3</option>
                        </select>
                        <a href="#">Learn More</a>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-flex justify-content-end">
                        <button type="button" class="btn text-primary">
                          <i
                            class="fa-solid fa-eye"
                            style={{ color: "#093177" }}
                          ></i>
                          1
                        </button>
                        <button type="button" class="btn">
                          Import Issue
                        </button>
                        <button type="button" class="btn">
                          <i class="fa fa-ellipsis"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr />
                  {/* <!-- status Secoond row --> */}
                  <div class="row">
                    {/* <!-- Status --> */}
                    <div class="col-12">
                      <label for="">
                        Status{" "}
                        <span>
                          <i class="fa fa-circle-info"></i>
                        </span>
                      </label>
                    </div>
                    <div class="col-12  mb-3 status">
                      <select
                        name=""
                        id=""
                        class="mb-1 bg-light form-select-sm"
                      >
                        <option value="">To Do</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                      <p class="text-secondary m-0 p-0 fw-semibold">
                        This is the issue's initial status upon creation
                      </p>
                    </div>
                    {/* <!-- Summary --> */}
                    <div class="col-12  mb-3">
                      <label for="">
                        Summary <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name=""
                        id=""
                        class="form-control border inputbg border-2"
                      />
                    </div>
                    {/* <!-- Description --> */}
                    <div class="col-12 mb-3">
                      <label for="">Description</label>
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="5"
                        class="form-control"
                      ></textarea>
                    </div>
                    {/* <!-- Assignee --> */}

                    <div class="col-6 mb-3">
                      <label for="">Assignee</label>
                      <div class=" border border-2 bg-light p-1">
                        <i
                          class="fa-solid fa-circle-user fs-5"
                          style={{ color: "#a5a5a6" }}
                        ></i>
                        <input
                          type="text"
                          name=""
                          id=""
                          placeholder="Automatic"
                          class="border-0 bg-light "
                        />
                      </div>
                      <span>
                        <a href="" class="text-decoration-none fw-semibold">
                          Assign to me
                        </a>
                      </span>
                    </div>

                    {/* <!-- labels --> */}
                    <div class="col-12  ">
                      <label for="">labels</label>
                    </div>
                    <div class="col-6  mb-3">
                      <div>
                        <select name="" id="" class="mb-1 form-select bg-light">
                          <option value="">Select label</option>
                          <option value="">option2</option>
                          <option value="">option3</option>
                        </select>
                      </div>
                    </div>

                    {/* <!-- Reporter --> */}
                    <div class="col-12">
                      <label for="">
                        Reporter <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-6 mb-3">
                      <div class=" border border-2 bg-light p-1 d-flex">
                        <div class=" rounded-circle  text-center bg-primary text-white">
                          CT
                        </div>
                        <input
                          type="text"
                          name=""
                          id=""
                          placeholder="CodeFirst Text"
                          class="border-0 bg-light "
                        />
                      </div>
                    </div>
                    {/* <!-- Attachment --> */}
                    <div class="col-12 col-md-6">
                      <label for="">Attachment</label>
                      <div class="border border-dotted text-center p-5">
                        <span>
                          <i class="fa fa-cloud-arrow-up"></i>Drop files to
                          attach or{" "}
                          <a href="#" class="text-decoration-none">
                            browse
                          </a>
                        </span>
                      </div>
                    </div>
                    {/* <!-- Linked Issues --> */}
                    <div class="col-6 mb-3">
                      <div>
                        <label for="">Linked Issues</label>
                        <select name="" id="" class="mb-1 form-select bg-light">
                          <option value="">Select label</option>
                          <option value="">option2</option>
                          <option value="">option3</option>
                        </select>
                        <select name="" id="" class="mb-1 form-select bg-light">
                          <option value="">Select label</option>
                          <option value="">option2</option>
                          <option value="">option3</option>
                        </select>
                      </div>
                    </div>
                    {/* <!-- Flagged --> */}
                    <div class="col-12">
                      <label for="">Flagged</label>
                    </div>
                    <div class="col-6 mb-3">
                      <div class=" rounded-2 bg-light border border-2 d-flex justify-content-between">
                        <input
                          type="text"
                          name=""
                          id=""
                          class="border-0 bg-light form-control"
                        />
                        <button class="btn border-0">
                          <i class="fa fa-chevron-down"></i>
                        </button>
                      </div>
                      <p class="text-secondary fw-semibold">
                        Allows to flag issues with impediments.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- model footer --> */}
              <div class="modal-footer justify-content-between">
                <div>
                  <input type="checkbox" name="" id="" />
                  <span>Create another issue</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" class="btn btn-primary">
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- main content --> */}
        {loading ? (
          <UILoader />
        ) : (
          <section class="pt-3">
            <div class=" container-fluid">
              <div class="row ">
                <div class="col-lg-8 col-md-12 first-col">
                  <div class="border border-top-0 px-3">
                    <div class="row">
                      {/* <div class="col-lg-12 col-md-12">
                                <div>
                                    <nav aria-label="breadcrumb ">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a class="text-decoration-none text-muted"
                                                    href="#">Projects</a>
                                            </li>
                                            <li class="breadcrumb-item"><a class="text-decoration-none text-muted"
                                                    href="#">Glitch-Found</a>
                                            </li>
                                            <li class="breadcrumb-item "><i class="fa fa-pencil"></i><a
                                                    class="text-decoration-none text-muted" href="#">Add-epic</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">
                                                <input type="checkbox" name="" id=""/><span> <a
                                                        class="text-decoration-none text-muted"
                                                        href="#">GF-20</a></span>
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div> */}
                      {/* <div class="col-lg-12 col-md-12 ">
                                <div class="heading-hover">
                                    <h1>Extra Fields in Ticket Creation</h1>
                                </div>
                            </div> */}
                      {/* <div class="col-lg-12 col-md-12">
                                <div>
                                    <button type="button" class="btn btn-light attach me-1"><i
                                            class="fa-solid fa-paperclip"></i>Attach</button>
                                    <button type="button" class="btn btn-light child-issue me-1">Add a child
                                        issue</button>
                                    <button type="button" class="btn btn-light link-issue "><i
                                            class="fa-solid fa-link"></i>Link
                                        issue
                                    </button>
                                    <button type="button" class="btn btn-light down-arrow border-start "><i
                                            class="fa fa-angle-down"></i></button>
                                </div>
                            </div> */}

                      <div class="col-lg-12 col-md-12 mt-3 desciption">
                        <p class="fw-bold pb-2 m-0">Ticket Details</p>
                        <div className="txn-item" key={data?.id}>
                          <div className="txn-head" id="txnhead1">
                            <div
                              className="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#txn1"
                              aria-expanded="false"
                              aria-controls="txn1"
                            >
                              <div
                                className={`txncard ${
                                  data?.currentStatus == "CLOSED"
                                    ? "success grbg"
                                    : "pending ylbg"
                                }`}
                              >
                                <div className="row">
                                  <div className="col-12 col-md-4">
                                    <div className="txntxt">
                                      <h6>
                                        <span>
                                          {" "}
                                          {data?.createdOn !== undefined &&
                                            data?.createdOn !== null &&
                                            createdOnDate(data?.createdOn)}
                                        </span>{" "}
                                        {/* ₹ {data.transaction.amount}{" "} */}
                                      </h6>
                                      <h6>{data?.payInTxn?.receivingVpa}</h6>
                                      <h6>{data?.payInTxn?.bank} </h6>
                                    </div>
                                  </div>
                                  <div className={`col-12 col-md-4`}>
                                    <div
                                      className="txntxt"
                                      onClick={() =>
                                        copyTextToClipboard(
                                          data?.payInTxn?.requestId,
                                          toast
                                        )
                                      }
                                    >
                                      <h6>
                                        TicketId: {data?.ticketId}{" "}
                                        {/* <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  /> */}
                                      </h6>

                                      {/* </li> */}
                                    </div>
                                  </div>

                                  <div
                                    // className="col-12 col-md-3"
                                    className="col-12 col-md-4"
                                  >
                                    <div className="txntxt">
                                      <h6
                                        onClick={() =>
                                          copyTextToClipboard(
                                            utrLeng(data?.payInTxn?.utr),
                                            toast
                                          )
                                        }
                                      >
                                        <h6>TxnID: {data?.txnId} </h6>
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12 col-md-12 mt-3 desciption">
                        <p class="fw-bold pb-2 m-0">Description</p>
                        <div class="description-div  pb-3 px-1 ">
                          <p>{data?.description}</p>
                        </div>
                      </div>
                      {/* <div class="col-lg-12 col-md-12 mt-1">
                        <div class="attachment d-flex justify-content-between align-items-center">
                          <div>
                            <p class="fw-semibold">
                              Attachment1 (
                              {Array.isArray(imgdata) && imgdata.length > 0
                                ? imgdata.length
                                : 0}
                              )
                            </p>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="col-12 mb-3 col-md-6">
                        <div>
                          <label htmlFor="attachment">Attachment</label>
                          <div
                            className="border border-dotted text-center py-1 px-2"
                            style={{
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <label
                              htmlFor={MERCHANTIMAGE}
                              className="text-decoration-none"
                              style={{ fontSize: "14px" }}
                            >
                              <i className="fa fa-cloud-arrow-up"></i> Drop
                              files to attach or browse
                            </label>
                            <input
                              disabled={data?.status == "RESOLVED"}
                              name={MERCHANTIMAGE}
                              type="file"
                              id={MERCHANTIMAGE}
                              accept="image/png, image/jpeg"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />
                          </div>
                          {attachmentId?.name ? (
                            <p style={{ fontSize: "12px" }}>
                              Selected file: {attachmentId?.name}
                            </p>
                          ) : (
                            <p style={{ fontSize: "12px" }}></p>
                          )}
                        </div>
                      </div>

                      <div className="col-12 mb-3 col-md-6">
                        <div>
                          <label htmlFor="attachment">
                            Internal Attachment
                          </label>
                          <div
                            className="border border-dotted text-center py-1 px-2"
                            style={{
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <label
                              htmlFor={INTERNALIMAGE}
                              className="text-decoration-none"
                              style={{ fontSize: "14px" }}
                            >
                              <i className="fa fa-cloud-arrow-up"></i> Drop
                              files to attach or browse
                            </label>
                            <input
                              name={INTERNALIMAGE}
                              type="file"
                              id={INTERNALIMAGE}
                              accept="image/png, image/jpeg"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                              // disabled={
                              //   !checkPermission(
                              //     TICKET_DETAILS_INTERNAL_ATTACH_IMAGE_EDIT,
                              //     roles
                              //   ) || data?.status == "RESOLVED"
                              // }
                            />
                          </div>
                          {internalattachmentId?.name ? (
                            <p style={{ fontSize: "12px" }}>
                              Selected file: {internalattachmentId?.name}
                            </p>
                          ) : (
                            <p style={{ fontSize: "12px" }}></p>
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-lg-12 col-md-12 attachment-card">
                        {Array.isArray(imgdata) && imgdata.length > 0 ? (
                          imgdata.map((val, index) => (
                            <div
                              key={index}
                              className="card"
                              style={{
                                height: "100px",
                                width: "150px",
                                cursor: "pointer",
                              }}
                            >
                              <div>
                                <img
                                  onClick={() =>
                                    openImageModal(val?.base64Content)
                                  }
                                  style={{ height: "100px", width: "150px" }}
                                  src={`data:image/jpeg;base64,${val?.base64Content}`}
                                  className="card-img-top"
                                  alt={`Attachment ${index}`}
                                />
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>No attachments found</p>
                        )}

                         {show && (
                          <ImageModal
                            show={show}
                            base64Content={selectedImage}
                            handleClose={closeImageModal}
                          />
                        )} 
                      </div> */}

                      <div class="col-lg-12 col-md-12 mt-5">
                        {/* <p class="fw-semibold">Activity</p> */}
                        <hr />
                        <div class="d-flex justify-content-between">
                          <div>
                            <span style={{ marginRight: "5px" }}>Show :</span>
                            {/* <button type="button" class="btn btn-light attach me-2">
                          {" "}
                          All
                        </button> */}
                            <button
                              type="button"
                              class="btn btn-light attach me-2 active commnets-btn"
                            >
                              Comments
                            </button>
                            {/* <button type="button" class="btn btn-light attach me-2">
                          {" "}
                          History
                        </button> */}
                          </div>

                          {/* <div>
                        <button type="button" class="btn btn-light attach me-2">
                          <i class="fa  fa-bars-sort"></i>
                          Order First{" "}
                        </button>
                      </div> */}
                        </div>
                      </div>

                      <div class="col-lg-12 col-md-12 mt-4">
                        <div class="row activity">
                          <div class="col-lg-1 col-md-1  "></div>
                        </div>
                      </div>
                      {/* <div class="col-lg-12 col-md-12 mt-2">
                        <div class="row activity">
                          <div class="col-lg-1 col-md-1   "></div>
                        </div>
                      </div> */}

                      {/* {checkPermission(
                        TICKET_DETAILS_INTERNAL_COMMENT_VIEW,
                        roles
                      ) && ( */}
                      {/* <>
                        <div onClick={toggleInternalCollapse}>
                          <DropdownMenus comments="Internal comments" />
                        </div>
                        <div
                          className={`${
                            isinternalCollapsed ? "collapseds" : ""
                          }`}
                        >
                          {Array.isArray(data?.internalComments) &&
                            data?.internalComments.length > 0 &&
                            data?.internalComments.map((comt) => (
                              <div
                                className={`col-lg-12 col-md-12 mt-2 ${
                                  isinternalCollapsed ? "collapseds" : ""
                                }`}
                              >
                                <div className="row activity">
                                  <div class="col-lg-1 col-md-1   ">
                                    <div class="rounded-circle bg-primary text-center  w-75 py-1">
                                      <p class="text-white">
                                        {getInitials(comt?.by)}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="col-lg-11 col-md-11">
                                    <div class="d-flex">
                                      <p class="me-3 fw-semibold">{comt?.by}</p>
                                      <p>
                                        {moment(comt?.ts).format(
                                          "DD-MM-YYYY hh:mm:ss"
                                        )}
                                      </p>
                                    </div>
                                    <div style={{ marginBottom: "10px" }}>
                                      <p>{comt?.text}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          <div class="col-lg-12 col-md-12 mt-2 ">
                            <div class="row activity">
                              <div class="col-lg-1 col-md-1  ">
                                <div
                                  style={{ marginTop: "10px" }}
                                  class="rounded-circle bg-primary text-center   w-75 py-1"
                                >
                                  <p class="text-white">
                                    {getInitials(profileInfo?.id)}
                                  </p>
                                </div>
                              </div>
                              <div
                                style={{ marginBottom: "5px" }}
                                class="col-lg-11 col-md-11 mt-2"
                              >
                                <div
                                  style={{ display: "flex" }}
                                  class=" comment"
                                >
                                  <input
                                    onChange={(e) =>
                                      setInternalcomments(e.target.value)
                                    }
                                    type="text"
                                    name=""
                                    id=""
                                    value={internalcomments}
                                    placeholder="Add Comments...."
                                    class="form-control"
                                  />
                                 
                                  <button
                                    style={{
                                      marginLeft: "5px",
                                      float: "right",
                                    }}
                                    onClick={() =>
                                      submitInternalChange(COMMENTS)
                                    }
                                    type="button"
                                    class="btn btn-primary"
                                    disabled={data?.status == "RESOLVED"}
                                  >
                                    {" "}
                                    Comment
                                  </button>
                                  {/* )} 
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>{" "}
                      </> */}
                      {/* )} */}
                      {/* {checkPermission(TICKET_DETAILS_COMMENT_VIEW, roles) && ( */}
                      <>
                        <div onClick={toggleCollapse}>
                          <DropdownMenus comments="All comments" />
                        </div>

                        <div className={`${isCollapsed ? "collapseds" : ""}`}>
                          {Array.isArray(data?.commentList) &&
                            data?.commentList.length > 0 &&
                            data?.commentList.map((comt) => (
                              <div
                                className={`col-lg-12 col-md-12 mt-2 ${
                                  isCollapsed ? "collapseds" : ""
                                }`}
                              >
                                <div className="row activity">
                                  <div class="col-lg-1 col-md-1   ">
                                    <div class="rounded-circle bg-primary text-center  w-75 py-1">
                                      <p class="text-white">
                                        {getInitials(comt?.commentedBy)}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="col-lg-11 col-md-11">
                                    <div class="d-flex">
                                      <p class="me-3 fw-semibold">
                                        {comt?.commentedBy}
                                      </p>
                                      <p>{comt?.time}</p>
                                    </div>
                                    <div style={{ marginBottom: "10px" }}>
                                      <p>{comt?.comment}</p>
                                      {/* <p>
                            <a
                              class="me-1 text-decoration-none text-muted fw-semibold"
                              href="#"
                            >
                              Edit
                            </a>
                            .
                            <a
                              class="me-1 text-decoration-none text-muted fw-semibold"
                              href="#"
                            >
                              Delete
                            </a>
                            .
                            <button
                              type="button"
                              class="btn btn-light attach me-1"
                            >
                              <i class="fa-solid fa-face-smile"></i>
                            </button>
                          </p> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          <div class="col-lg-12 col-md-12 mt-2 ">
                            <div class="row activity">
                              <div class="col-lg-1 col-md-1  ">
                                <div
                                  style={{ marginTop: "10px" }}
                                  class="rounded-circle bg-primary text-center   w-75 py-1"
                                >
                                  <p class="text-white">
                                    {getInitials(profileInfo?.id)}
                                  </p>
                                </div>
                              </div>
                              <div
                                style={{ marginBottom: "5px" }}
                                class="col-lg-11 col-md-11 mt-2"
                              >
                                <div
                                  style={{ display: "flex" }}
                                  class=" comment"
                                >
                                  <input
                                    onChange={(e) =>
                                      setComments(e.target.value)
                                    }
                                    type="text"
                                    name=""
                                    id=""
                                    value={comments}
                                    placeholder="Add Comments...."
                                    class="form-control"
                                  />
                                  {
                                    <button
                                      style={{
                                        marginLeft: "5px",
                                        float: "right",
                                      }}
                                      onClick={submitComment}
                                      type="button"
                                      class="btn btn-primary"
                                      // disabled={
                                      //   !checkPermission(
                                      //     TICKET_DETAILS_COMMENT_EDIT,
                                      //     roles
                                      //   ) || data?.status == "RESOLVED"
                                      // }
                                    >
                                      {" "}
                                      Comment
                                    </button>
                                  }
                                  {/* <p class=""><span class="fw-bold">Pro Tip :</span> press
                                                <button onClick={submitComment} type="button" class="btn btn-secondary me-2"> M</button>to
                                                comment1
                                            </p> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                      {/* )} */}
                    </div>
                  </div>
                </div>
                {/* <!-- seccond column --> */}
                <div class="col-lg-4 col-md-12 second-col">
                  <div class="container">
                    <div class="row mt-5">
                      {/* <div class="col-12">
                    <div class="d-flex justify-content-end">
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-eye"></i>2
                      </button>
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-thumbs-up"></i>
                      </button>
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-share-nodes"></i>
                      </button>
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                    </div>
                  </div> */}
                    </div>
                    <div class="row">
                      <div className="col-lg-12 col-md-12">
                        <div className="d-flex align-items-center gap-2">
                          <div className="col-12 col-md-4">
                            <select
                              style={{ border: "1px solid #E7E5E5" }}
                              value={selectedStatusOption}
                              onChange={handleDropdownChange}
                              className="bg-light form-select-sm w-100"
                              disabled={data?.status === "RESOLVED"}
                            >
                              {TicketStatusoptions.map((val) => (
                                <option key={val?.value} value={val?.value}>
                                  {val?.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-12 col-md-6">
                            <input
                              type="text"
                              placeholder="Enter Assign to "
                              value={assignTo}
                              onChange={(e) => setAssignTo(e.target.value)}
                              className="border-0 bg-light form-control w-100"
                            />
                          </div>

                          <button
                            className="border-0 bg-transparent"
                            type="button"
                            onClick={submitStatus}
                            disabled={checkDisableBystatus()}
                          >
                            <IoMdCheckmarkCircle
                              size={35}
                              style={
                                !checkDisableBystatus()
                                  ? { color: primaryColor }
                                  : { color: "#E3E3E3" }
                              }
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <div class="mt-3">
                          <div class="card">
                            {/* <div class="card-header bg-white d-flex justify-content-between">
                          <p>Your pinned fields</p>
                          <span>
                            <i class="fa fa-angle-down ms-2"></i>
                          </span>
                        </div> */}
                            <div class="card-body">
                              <div class="row">
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    Last Assignee
                                  </p>
                                </div>
                                <div class="col-lg-6 col-md-6 align-items-center">
                                  <div class="d-flex">
                                    <i class="fa-solid fa-circle-user fs-3 me-2"></i>
                                    <span>
                                      {" "}
                                      {data?.lastAssignedTo !== undefined &&
                                      data?.lastAssignedTo !== null &&
                                      data?.lastAssignedTo
                                        ? data?.lastAssignedTo
                                        : "UnAssigned"}{" "}
                                    </span>
                                  </div>
                                  {/* <div class="row">
                                <div class="col-lg-12 col-md-12">
                                  <a href="#" class="text-decoration-none">
                                    Assign to me
                                  </a>
                                </div>
                              </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12">
                        <div class="mt-3">
                          <div class="card">
                            <div class="card-header bg-white d-flex justify-content-between">
                              <p>Details</p>
                              <span>
                                <i class="fa fa-angle-down ms-2"></i>
                              </span>
                            </div>
                            <div class="card-body">
                              <div class="row">
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    Created By
                                  </p>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    {data?.createdBy}
                                  </p>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    Created On
                                  </p>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    {data?.createdOn !== undefined &&
                                      moment(data?.createdOn).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}
                                  </p>
                                </div>

                                {/* <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Assigned To</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="row">
                                <div class="d-flex align-items-center">
                                  <div class="col-lg-4 col-md-4">
                                    <div class="rounded-circle bg-primary text-center w-75 ">
                                      <p class="text-white m-0 p-0">{getInitials(data?.assignedTo) || "NA"}</p>
                                    </div>
                                  </div>
                                  <div class="col-lg-9 col-md-9">
                                    <div>
                                      <p class="ms-2">{data?.assignedTo}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    Closed By
                                  </p>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                  <p class="fw-bold text-secondary">
                                    {data?.closedBy}
                                  </p>
                                </div>
                                {!data?.closedOn && (
                                  <>
                                    <div class="col-lg-6 col-md-6">
                                      <p class="fw-bold text-secondary">
                                        Open since
                                      </p>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                      <p className="fw-bold text-secondary">
                                        {data?.closedOn
                                          ? moment(data.closedOn).format(
                                              "DD-MM-YYYY HH:mm:ss"
                                            )
                                          : calculateTimeDifference(
                                              data?.createdOn,
                                              getTodaytDateTime(),
                                              userTimeZone
                                            )}
                                      </p>
                                    </div>
                                  </>
                                )}
                                {data?.closedOn && (
                                  <>
                                    <div class="col-lg-6 col-md-6">
                                      <p class="fw-bold text-secondary">
                                        Closed on
                                      </p>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                      <p class="fw-bold text-secondary">
                                        {moment(data?.closedOn).format(
                                          "DD-MM-YYYY HH:mm:ss"
                                        )}
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      {/* <div class="col-lg-12 col-md-12">
                    <div class="d-flex justify-content-between configure">
                      <p class=" ">Created last week</p>
                      <div>
                        <i class="fa-solid fa-gear"></i>
                        <a
                          href="#"
                          class="text-decoration-none text-muted fw-semibold "
                        >
                          Configure
                        </a>
                      </div>
                    </div>
                  </div> */}
                      <div class="col-lg-12 col-md-12 configure">
                        <p>
                          Last Updated on{" "}
                          {data?.updatedOn &&
                            calculateTimeDifference(
                              data?.updatedOn,
                              getTodaytDateTime(),
                              userTimeZone
                            )}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
    // ) : (
    //   <p>{nopagepermission}</p>
    // );
  );
}
